<template>
    <li class="group cursor-pointer px-0 lg:px-1">
        <a class="group-hover:text-blue-400 text-sm font-medium tracking-widest lg:tracking-wide block whitespace-nowrap border-b-2 py-4 lg:py-3 outline-none focus-visible:text-blue-400 select-none px-4 lg:px-2"
            :class="active ? 'text-white border-white' : 'text-gray-400 border-transparent'"
            :href="href"
        >
            {{ $t(label) }}
        </a>
    </li>
</template>

<script>
export default {
    props: {
        label: {},
        href: {},
        active: { default: false },
    },
}
</script>

